﻿import config from "../config"
const baseUrl = config.base_url + "lz_tree/"
export default {
    page: {
        url:  baseUrl + "treeAndGrowDataPage/{organId}/{areaId}/{limit}/{page}",
        type: "post",
    }
}

